import React from "react";

// Shared, theme-aware Recharts tooltip. Readable in light AND dark themes (WCAG AA).
export default function ChartTooltip({ active, payload, label }) {
  if (!active || !payload || !payload.length) return null;
  return (
    <div className="rounded-xl border border-border bg-popover text-popover-foreground shadow-xl px-3 py-2 text-xs">
      {label != null && label !== "" && <div className="font-semibold mb-1 text-foreground">{label}</div>}
      <div className="space-y-0.5">
        {payload.map((p, i) => (
          <div key={i} className="flex items-center gap-2">
            <span className="h-2.5 w-2.5 rounded-full shrink-0" style={{ background: p.color || p.payload?.fill || "hsl(var(--primary))" }} />
            <span className="text-muted-foreground">{p.name}</span>
            <span className="font-bold text-foreground ml-auto">{p.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
